import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PartnersCarousel = () => {
  const partners = [
    { name: "Holy", image: "./assets/partners/holy-logo.png", white: true },
    { name: "Razer", image: "./assets/partners/razer-logo.png", white: true },
    { name: "Quersus", image: "./assets/partners/quersus-logo.png", white: true },
    { name: "Make-It-Shine", image: "./assets/partners/make-it-shine-logo.png", white: true },
    { name: "Free", image: "./assets/partners/free-logo.png", white: true },
    { name: "Logitech", image: "./assets/partners/logitech-logo.png", white: true },
  ];

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "60px",
    focusOnSelect: true,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "20px", // Réduit le padding pour mobile
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "40px",
        },
      }
    ],
  };

  return (
    <section className="partners-carousel overflow-hidden flex-col justify-center" style={{ backgroundColor: '#0a0101' }}>
      <div className="container mx-auto px-4 mb-20 flex justify-center">
        <h2 className="text-4xl font-bold text-white text-center" style={{ letterSpacing: '1.5px' }}>Nos partenaires</h2>
      </div>

      <div className="relative w-full">
        <Slider {...settings}>
          {partners.map((partner, index) => (
            <div
              key={index}
              className="relative w-full h-36 md:h-48 rounded-lg overflow-hidden flex items-center justify-center mx-4"
            >
              <div className="w-full h-full flex items-center justify-center">
                <img
                  src={partner.image}
                  alt={partner.name}
                  className={`cursor-pointer max-w-full max-h-full object-contain transition-all duration-300 ${partner.white ? 'brightness-0 invert' : ''}`}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '150px'
                  }}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default PartnersCarousel;